export default __webpack_public_path__ + "static/media/cp_geo_tz.259f5860.svg";